import { CustomPaginationProps, Pagination } from '@lfg/ui/components';

export function AppPagination(props: CustomPaginationProps) {
  const { sx, ...rest } = props;
  return (
    <Pagination
      component={'div'}
      sx={{
        color: 'white',
        ...sx,
      }}
      slotProps={{
        select: {
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor: 'black',
                color: '#ffffff',
                borderRadius: '8px',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                '& .MuiMenuItem-root': {
                  '&.Mui-selected': {
                    backgroundColor: '#424242',
                    color: '#ffffff',
                  },
                  '&:hover': {
                    backgroundColor: '#616161',
                  },
                },
              },
            },
          },
          sx: {
            '& .MuiSelect-icon': {
              color: 'white',
            },
          },
        },
      }}
      {...rest}
    />
  );
}
